import { booleanAttribute, Component, Input } from '@angular/core';
import { NgClass } from '@angular/common';
import { MatIcon } from '@angular/material/icon';

@Component({
  selector: 'car-placeholder-or-photo',
  templateUrl: './car-placeholder-or-photo.component.html',
  styleUrls: ['./car-placeholder-or-photo.component.scss'],
  imports: [NgClass, MatIcon]
})
export class CarPlaceholderOrPhotoComponent {
  @Input({ transform: booleanAttribute }) repairerTile = false;
  @Input() preSignedUrl: string;
  @Input() rego: string;
  photoLoaded = false;
}
